import React, { useRef, useEffect } from "react";
/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlerter(ref, callback) {
	useEffect(() => {
		/**
		 * Alert if clicked on outside of element
		 */
		function handleClickOutside(event) {
			if (ref.current && !ref.current.contains(event.target)) {
				// alert("You clicked outside of me!");
				callback && callback();
			}
		}
		// Bind the event listener
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref]);
}

/**
 * Component that alerts if you click outside of it
 */
function OutsideAlerter({ children,className, callback }) {
	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef, callback);
	return (
		<div ref={wrapperRef} className={className}> {children} </div>
	)
}


export default OutsideAlerter;
